export { default } from './ProfessorsSection';
